import { render, staticRenderFns } from "./CompanyBills.vue?vue&type=template&id=417540c0&"
import script from "./CompanyBills.vue?vue&type=script&lang=js&"
export * from "./CompanyBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports